import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import {
  AutocompleteInput,
  AutocompleteInputProps,
} from '../AutocompleteInput';

export function AutocompleteInputForm<T extends FieldValues>({
  control,
  name,
  defaultValue,
  items,
  ...rest
}: UseControllerProps<T> &
  Omit<AutocompleteInputProps, 'value' | 'onValueChanged'>) {
  const {
    field,
    fieldState: { invalid, error },
  } = useController({ control, name, defaultValue });

  const value = field.value
    ? items.find(item => item.value === field.value)
    : undefined;

  return (
    <AutocompleteInput
      value={value}
      onSelect={value => field.onChange(value.value)}
      error={error?.message}
      items={items}
      {...rest}
    />
  );
}
